<template>
<Loader :isLoading="isLoading"/>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-4 mb-2">
          <div class="nav-wrapper position-relative end-0">
            <ul class="nav nav-pills nav-fill p-1" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link mb-0 px-0 py-1"
                  :class="{'active': active, '': !active }"
                  data-bs-toggle="tab"
                  role="tab"
                  aria-selected="true"
                  @click="changeTab(1)"
                  style="cursor:pointer;"
                  >Conductores</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link mb-0 px-0 py-1"
                  data-bs-toggle="tab"
                  :class="{'active': !active, '': active}"
                  role="tab"
                  @click="changeTab(2)"
                  style="cursor:pointer;"
                  aria-selected="false"
                  >Clientes</a
                >
              </li>
            </ul>
        </div>
      </div>
      <div class="col-12" v-show="!isLoading">
 
        <div class="card" v-show="active">
 
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">Lista de conductores</h5>
              </div>
              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto">
                  <router-link
                    :to="{ name: 'Registrar Usuario' }"
                    class="mb-0 btn bg-gradient-danger btn-sm"
                    >+&nbsp; Nuevo Conductor</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="px-0 pb-0 card-body mx-4 my-3">
            <div class="table-responsive">
              <table id="drivers-list" class="table table-flush">
                <thead class="thead-light">
                  <tr>
                    <th  style="font-size: 0.65em; font-weight: bold; text-align: start">#</th>
                    <th style="font-size: 0.65em; font-weight: bold">Nombre</th>
                    <th style="font-size: 0.65em; font-weight: bold">Correo</th>
                    <th style="font-size: 0.65em; font-weight: bold">Usuario</th>
                    <th style="font-size: 0.65em; font-weight: bold">Estatus</th>
                    <th style="font-size: 0.65em; font-weight: bold;">Acciones</th>
 
                  </tr>
                </thead>
              <tbody >
                  <tr v-for="({email, name, username, status, id}, index) in users" :key="index" >
                    <td>
                      {{(index + 1)}}
                    </td>
                     <td class="text-sm">{{name}}</td>
                    <td class="text-sm">{{email}}</td>
                    <td class="text-sm">{{username}}</td>
                    <td>
                      <span class="badge  badge-sm" :class="{'badge-success': status, 'badge-danger': !status}"
                        >{{status ? 'Activo' : 'Inactivo'}}</span
                      >
                    </td>
                    <td class="text-sm">
 
                      <a
                        title="Actualizar conductor"
                        @click="updateDriver(id)"
                        class="clickeable"
                      >
                        <i class="fa fa-cog text-secondary"></i>
                      </a>
                      
                        <a
                        title="Visualizar conductor"
                        @click="detailDriver(id)"
                        class="mx-3 clickeable"
                      >
                        <i class="fas fa-eye text-secondary"></i>
                      </a>
                      <a
                        title="Desactivar conductor"
                        @click="changeStatusDriver(id, username)"
                        class="clickeable me-3"
                        v-if="status"
                      >
                        <i class="fa fa-times-circle text-secondary" ></i>
                      </a>
                        <a
                        title="Activar conductor"
                        @click="changeStatusDriver(id, username)"
                        class="clickeable me-3"
                        v-if="!status"
                        >
                        <i class="fa fa-check-circle text-secondary" ></i>
                      </a>
                        <a
                        title="Visualizar puntaje"
                        @click="viewDetailsDriver({id: id})"
                        class="clickeable me-3"
                        >
                        <i class="fa fa-star text-secondary" ></i>
                      </a>
                      <!-- Icono para eliminar el conductor permanentemente -->
                      <a
                        title="Eliminar conductor"
                        @click="deleteDriver(id, username)"
                        class="clickeable"
                      >
                        <i class="fa fa-trash text-danger"></i>
                      </a>
                    </td>
                  </tr>
                  
                </tbody>
              </table>
            </div>
          </div>
        </div>
 
        <div class="card" v-show="!active">
          <!-- Card header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div>
                <h5 class="mb-0">Lista de clientes</h5>
              </div>
            </div>
          </div>
          <div class="px-0 pb-0 card-body  mx-4 my-3">
            <div class="table-responsive">
              <table id="clients-list" class="table table-flush">
                <thead class="thead-light">
                  <tr>
                    <th style="font-size: 0.65em; font-weight: bold; text-align: start">#</th>
                    <th style="font-size: 0.65em; font-weight: bold;">Nombre</th>
                    <th style="font-size: 0.65em; font-weight: bold;">Correo</th>
                    <th style="font-size: 0.65em; font-weight: bold;">Usuario</th>
                    <th style="font-size: 0.65em; font-weight: bold;">Estatus</th>
                    <th style="font-size: 0.65em; font-weight: bold;">Acciones</th>
                  </tr>
                </thead>
              <tbody>
                  
                  <tr v-for="({email, name, username, status, id }, index) in consumers" :key="index">
                    <td>
                      {{(index + 1)}}
                    </td>
                    <td class="text-sm">{{name}}</td>
                    <td class="text-sm">{{email}}</td>
                    <td class="text-sm">{{username}}</td>
                    <td>
                      <span class="badge  badge-sm" :class="{'badge-success': status, 'badge-danger': !status}"
                        >{{status ? 'Activo' : 'Inactivo'}}</span
                      >
                    </td>
                    <td class="text-sm">
                        <a
                        title="Visualizar cliente"
                        @click="detailDriver(id)"
                        class="clickeable me-3"
                      >
                        <i class="fas fa-eye text-secondary"></i>
                      </a>
                      <a
                        title="Desactivar cliente"
                        @click="changeStatusClient(id,username )"
                        class="clickeable"
                        v-if="status"
                      >
                        <i class="fa fa-times-circle text-secondary" ></i>
                      </a>
                        <a
                        title="Activar cliente"
                        @click="changeStatusClient(id, username)"
                        class="clickeable"
                        v-if="!status"
                        >
                        <i class="fa fa-check-circle text-secondary" ></i>
                      </a>
                    </td>
                  </tr>
                  
                </tbody>
                  <tfoot>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
   <MDBModal
    id="newRouteEndPositionModal"
    tabindex="-1"
    labelledby="newRouteEndPositionModalLabel"
    v-model="qualicationsModal"
  >
    <MDBModalHeader>
      <MDBModalTitle id="exampleModalLabel">Calificación del conductor</MDBModalTitle>
    </MDBModalHeader>
    <MDBModalBody>
          <LoaderModal :isLoading="isLoadingModal"/>
            <div class="container-d" v-show="!isLoadingModal">
              <div class="row">
                  <div class="col-12 text-center">
                       <img
                        alt="Image placeholder"
                        :src="searchedUser.profile"
                        class="rounded-circle me-2"
                        style="cursor:pointer;"
                        />
                        <span class="fw-bold d-block mt-2">{{searchedUser.username}}</span>
                  </div>
                  <hr class="my-3 horizontal dark" />
                  <div class="col-12 text-center">
                      <star-rating class="star" v-model:rating="qualication" :show-rating="false" :active-on-click="false" :read-only="true" :increment="0.5" :star-size="35"/>
                  </div>
                  <hr class="my-3 horizontal dark" />
                  <div class="col-12" v-show="comments.length !== 0">
                     <h5 class="mb-2">Comentarios</h5>
                  </div>
                  <div class="col-12" v-show="comments.length !== 0">
                    <div class="container" style="overflow: auto !important;  height: 10em; ">
                      <div class="row">
                        <div class="col-12 card mt-2" v-for="(item, index) in comments" :key="index">
                           <div class="d-flex">
                              <div class="flex-grow-1 ms-3">
                                <h6 class="mt-0 ">{{item.user}}</h6>
                                <p class="text-sm">
                                  {{item.comments}}
                                </p>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
 
                  </div>
 
                  <div class="col-12 text-center" v-show="comments.length === 0">
                     <span class="fw-bold d-block mt-2">Sin comentarios disponibles</span>
                  </div>
              </div>
            </div>
 
    </MDBModalBody>
    <MDBModalFooter >
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 text-center">
            <button  class="btn bg-gradient-dark" title="Cerrar" @click="closeModal()">Cerrar</button>
          </div>
        </div>
      </div>
    </MDBModalFooter>
  </MDBModal>
</template>
 
<script>
import setNavPills from "@/assets/js/nav-pills.js";
import DataTable from 'datatables.net-dt';
import setTooltip from "@/assets/js/tooltip.js";
import listUsers from '../../use-cases/list.user.js';
import getQualificationAverage from '../../use-cases/get.qualification.average';
import getRandomComments from '../../use-cases/get.random.comments';
import listConsumers from '../../use-cases/list.consumers.js';
import changeStatusUser from '../../use-cases/change.status.user';
import deleteUserUseCase from '../../use-cases/delete.user.js'; 
import Loader from '../../../../components/Loader.vue';
import LoaderModal from '../../../../components/LoaderModal.vue';
import $ from 'jquery';
import router from '../../../../router/index';
import Types from '../../../../kernel/translate/imageType';
import getUser from '../../use-cases/get.user';
import StarRating from 'vue-star-rating';
 
import {  
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalFooter
} from 'mdb-vue-ui-kit';
 
export default {
  name: "ProductsList",
  components:{
    Loader,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalFooter,
    StarRating,
    LoaderModal
  },
  data(){
    return{
      users: [],
      consumers: [],
      active: true,
      value: true,
      isLoading: false,
      storeDatatableDriver: null,
      storeDatatableClient: null,
      comments: [],
      qualication: 0,
      qualicationsModal: false,
      searchedUser: {},
      isLoadingModal: false,
    }
  },
 
  async mounted() {
    setNavPills();
    this.active = true;
    await this.datatableDriver();
    setTooltip(this.$store.state.bootstrap);
  },
  methods:{
    async getUser(id){
      const response = {...await getUser(id)};
      const {error, data} = response;
        if(!error){
          const {result:{profile}} = data
          const {result} = data
          this.searchedUser = result;
          this.searchedUser = {...this.searchedUser, profile: `data:image/${Types.getTypeFromImage(profile)};base64,${profile}`}
          
      }else{
           this.$swal({
            icon: "error", 
            title: 'Ocurrió un error durante la consultar. Inténtalo de nuevo.',
            type: "basic",
          });
      }
    },
    async listUsers(){
      this.isLoading = true;
      const response = {...await listUsers()};
      const {error, data} = response;
      this.isLoading = false;
      if(!error){
          const {result} = data
          this.users = result.map(user => ({...user, name: user.person.name === '' && (user.person.surname === ' ' ||  user.person.surname === '')? 'Sin nombre' : `${user.person.name} ${user.person.surname}`}))
 
      }else{
          this.$swal({
            icon: "error", 
            title: 'Ocurrió un error durante la consultar. Inténtalo de nuevo.',
            type: "basic",
          });
      }
    },
    async listConsumers(){
      this.isLoading = true;
      const response = {...await listConsumers()};
      const {error, data} = response;
      this.isLoading = false;
      if(!error){
          const {result} = data
          this.consumers = result.map(user => ({...user, name: ((user.person.name === '' || user.person.name === null) && (user.person.surname === ' ' ||  user.person.surname === '' || user.person.surname === null))? 'Sin nombre' : `${user.person.name} ${user.person.surname ? user.person.surname: ''}`}))
      }else{
          this.$swal({
            icon: "error", 
            title: 'Ocurrió un error durante la consultar. Inténtalo de nuevo.',
            type: "basic",
        });
      }
    },
    async getQualicationAverage(payload){
      const response = {...await getQualificationAverage(payload)};
      const {error, data} = response;
      if(!error){
          const {result} = data
         this.qualication = result
      }else{
          this.$swal({
            icon: "error", 
            title: 'Ocurrió un error durante la consultar. Inténtalo de nuevo.',
            type: "basic",
        });
      }
    },
    async getRandomComments(payload){
      const response = {...await getRandomComments(payload)};
      const {error, data} = response;
      if(!error){
          const {result} = data
          this.comments = result.map((comment) => ({...comment, user: /^\s*$/.test(comment.user) ? 'Anónimo' : comment.user }))
      }else{
          this.$swal({
            icon: "error", 
            title: 'Ocurrió un error durante la consultar. Inténtalo de nuevo.',
            type: "basic",
        });
      }
    },
    async changeStatusDriver (id, name){
      await this.changeStatus(id, 1,name)
    },
    async changeStatusClient(id, name){
      await this.changeStatus(id, 2, name)
    },
    async changeStatus(id, type, name){
       this.$swal({
            title: `¿Estás seguro(a) de cambiar el estatus de <strong>${name}</strong>?`,
            icon: "warning",
            type: "custom-html",
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonText: "Confirmar",
            customClass: {
              confirmButton: "btn bg-gradient-success",
              cancelButton: "btn bg-gradient-secondary",
            },
            buttonsStyling: false,
          }).then(async(result) => {
            if (result.isConfirmed) {
                this.isLoading = true;
                const response = {...await changeStatusUser(id)};
                const {error, data, message} = response;
                
                if(!error){
                    const {result:{text}} =data
                    this.$swal({
                      icon: "success",
                      title: message,
                      text: text,
                      type: 'success-message',
                    });
                    if(type === 1) await this.datatableDriver()
                    await this.datatableClient()
                  this.isLoading = false;
                }else{
                  this.isLoading = false;
                  const {data:{text}} = response;
                    this.$swal({
                      icon: "error", 
                      title: text,
                      type: "basic",
                  });
                }
            } else if (result.dismiss === this.$swal.DismissReason.cancel) {
              this.$swal.dismiss;
            }
          })
    },
    
    // Método de borrado limpio sin variables unused
    async deleteDriver(id, name) {
      this.$swal({
        title: `¿Estás seguro(a) de eliminar a <strong>${name}</strong>?`,
        text: "Esta acción eliminará al conductor de la plataforma.",
        icon: "warning",
        type: "custom-html",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Eliminar",
        customClass: {
          confirmButton: "btn bg-gradient-danger",
          cancelButton: "btn bg-gradient-secondary",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.isLoading = true;
          const response = { ...await deleteUserUseCase(id) };
          const { error, data } = response;

          if (!error) {
            // Remueve el usuario del arreglo local inmediatamente
            this.users = this.users.filter(u => u.id !== id);

            this.$swal({
              icon: "success",
              title: "Eliminado",
              text: `El conductor ${name} ha sido eliminado con éxito.`,
              type: 'success-message',
            });

            // Reconstruye la tabla con la lista limpia
            await this.datatableDriver();
          } else {
            this.isLoading = false;
            let errorMsg = data && data.text ? data.text : "No se pudo eliminar el usuario.";
            this.$swal({
              icon: "error",
              title: "Error al eliminar",
              text: errorMsg,
              type: "basic",
            });
          }
        }
      });
    },

    async datatableDriver(){
          // Destruir la tabla en memoria ANTES de pedir la lista nueva
          if (this.storeDatatableDriver) {
            this.storeDatatableDriver.destroy();
            this.storeDatatableDriver = null;
          }

          await this.listUsers();

          this.$nextTick(() => {
            this.storeDatatableDriver = new DataTable('#drivers-list', {
              searching: true,
              ordering: true,
              pageLength: 5,
              lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, "Mostrar todos"]],
              language: {
                infoEmpty: "",
                url: 'https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json',
                paginate: {
                  next: ">"
                },
                search: "",
                searchPlaceholder: "Buscar...",
              },
              pagingType: "simple_numbers",
              drawCallback: () => {
                $('#drivers-list_previous').addClass('d-none');
              },
              columnDefs: [
                {
                  targets: [0, 1, 2],
                  visible: true
                }
              ]
            });
          });
    },
    
    async datatableClient(){
          await this.listConsumers();
           if(this.storeDatatableClient){
            this.storeDatatableClient.destroy()
          }
          this.$nextTick(()=>{
            this.storeDatatableClient =  new DataTable('#clients-list', {
            searching: true,
            ordering: true,
            pageLength:5,
            lengthMenu: [[5, 10, 25, 50, -1], [5, 10, 25, 50, "Mostrar todos"]],
            language:{
              infoEmpty: "",
              url: 'https://cdn.datatables.net/plug-ins/1.13.6/i18n/es-ES.json',
              paginate: {
                    next: ">"
                  },
              search: "",
              searchPlaceholder: "Buscar...",
              
            },
            pagingType: "simple_numbers",
            drawCallback: ()=>{
                  $('#clients-list_previous').addClass('d-none');
            },
            columnDefs: [
                  {
                      targets: [0, 1, 2],
                      visible: true
                  }
            ]
            });
        })
    },
    async changeTab(tab){
      if(tab === 1){
        await this.datatableDriver();
        this.active=true;
      }else{
        await this.datatableClient();
        this.active=false;
      } 
    },
    detailDriver(id){
      router.push({name: 'Visualizar Usuario', params: {id: id}})
    },
    updateDriver(id){
      router.push({name: 'Modificar Usuario', params: {id: id}})
    },
    async viewDetailsDriver(payload){
        this.qualicationsModal = true;
        this.isLoadingModal = true;
        await this.getQualicationAverage(payload);
        await this.getRandomComments(payload);
        await this.getUser(payload.id)
        this.isLoadingModal = false;
 
    },
    closeModal(){
        this.qualicationsModal = false;
    }
  },
  
  watch:{
    users: async function(){
    }
  }
  
};
</script>
 
<style scoped>
  .clickeable{
    cursor: pointer;
  }
  .star{
    display: flex !important;
    justify-content: center;
    align-items: center;
  }
</style>